import './illustration.css';
import '../common/tablerixme.css';
import '../references-documentaires/references-documentaires.css';
import '../dossiers-carousel/dossiers-carousel.css';
import '../partenaires/partenaires.css';
import '../utils/utils.css';

import '../references-documentaires/references-documentaires.js';

import {
  clampLines,
  avoidUpscalingImage,
  checkImageInError,
  waitForImageLoaded,
} from '../utils/utils.js';
import { initDossiersCarousel } from '../dossiers-carousel/dossiers-carousel.js';
import {
  manageButton,
  manageSelectionLinkInHeader,
} from '../selection/utils.js';

document
  .querySelectorAll('.illustration-informations-techniques .tablerixme-element')
  .forEach((element) => {
    const valueElement = element.querySelector('.value');
    clampLines(valueElement, 3);
  });

initDossiersCarousel(
  document.querySelector('.illustration .dossiers-carousel'),
);

const selectionButton = document.querySelector('[data-action="selection:add"]');
if (selectionButton) {
  manageButton(selectionButton);
}

manageSelectionLinkInHeader();

const imageElement = document.querySelector('.illustration-plein-ecran img');
if (imageElement) {
  avoidUpscalingImage(imageElement);

  checkImageInError(imageElement, '.image-container');

  waitForImageLoaded(imageElement, () => {
    const illustrationWrapper = document.querySelector('.illustration');
    const imageRatio = imageElement.naturalWidth / imageElement.naturalHeight;
    if (imageRatio > 16 / 9) {
      illustrationWrapper.classList.add('panoramique');
    } else if (imageRatio > 1) {
      illustrationWrapper.classList.add('paysage');
    } else {
      illustrationWrapper.classList.add('portrait');
    }
  });
}
